import { useContext } from 'react';
import { ReportContext } from '../../context/ReportContext';
import Grid from '@mui/material/Grid2';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CobrandDropdown from './CobrandDropdown';
import TimeZoneDropdown from './TimeZoneDropdown';
import RunButton from './RunButton';

const ReportsHeader = () => {
    const {
        paramCobrand,
        setParamCobrand,
        cobrandOptions,
        clientOptions,
        canSelectClient,
        paramClient,
        setParamClient,
        unitOptions,
        paramUnit,
        setParamUnit,
        paramFromDate,
        setParamFromDate,
        paramToDate,
        setParamToDate,
        paramTimeZone,
        setParamTimeZone,
        getReportData,
        inFlight,
        noReportsAvailable,
        selectedReport,
    } = useContext(ReportContext);

    const hasOptions = cobrandOptions.length > 0 && unitOptions.length > 0;
    const isLoading = inFlight || (!noReportsAvailable && !hasOptions);
    const isDisabled = isLoading || noReportsAvailable;

    const clientDisplayName = paramClient === 'all'
        ? 'all clients'
        : clientOptions.find((c) => c.id === paramClient)?.name || 'the selected client';
    const reportDisplayName = selectedReport?.name || 'This report';

    return (
        <div className="my-4">
            <Grid container spacing={3} alignItems="center">
                <Grid size={12}>
                    <Grid container spacing={3}>
                        {canSelectClient && clientOptions.length > 0 && (
                            <Grid size={{ xs: 8, md: 3, xl: 2 }}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    disabled={isLoading || clientOptions.length === 1}
                                >
                                    <InputLabel id="client-label">client</InputLabel>
                                    <Select
                                        labelId="client-label"
                                        value={paramClient}
                                        onChange={(e) => setParamClient(e.target.value)}
                                        label="client"
                                    >
                                        {clientOptions.length > 1 && (
                                            <MenuItem value="all">All Clients</MenuItem>
                                        )}
                                        {clientOptions.map((client) => (
                                            <MenuItem key={client.id} value={client.id}>
                                                {client.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                        <Grid size={{ xs: 8, md: 3, xl: 2 }}>
                            <CobrandDropdown
                                paramCobrand={paramCobrand}
                                setParamCobrand={setParamCobrand}
                                cobrandOptions={cobrandOptions}
                                isLoading={isLoading}
                                isDisabled={noReportsAvailable}
                            />
                        </Grid>
                        <Grid size={{ xs: 8, md: 3, xl: 2 }}>
                            <FormControl
                                fullWidth
                                variant="outlined"
                                disabled={isDisabled || paramCobrand?.length > 1}
                            >
                                <InputLabel id="unit-label">unit</InputLabel>
                                <Select
                                    labelId="unit-label"
                                    value={paramUnit}
                                    onChange={(e) => setParamUnit(e.target.value)}
                                    label="unit"
                                >
                                    {unitOptions.map((x) => (
                                        <MenuItem key={x.id} value={x.id}>
                                            {x.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Grid container spacing={3}>
                        <Grid size={{ xs: 8, md: 3, xl: 2 }}>
                            <DatePicker
                                label="From Date"
                                value={paramFromDate}
                                onChange={setParamFromDate}
                                sx={{ width: '100%' }}
                                disabled={isDisabled}
                            />
                        </Grid>
                        <Grid size={{ xs: 8, md: 3, xl: 2 }}>
                            <DatePicker
                                label="To Date"
                                value={paramToDate}
                                onChange={setParamToDate}
                                sx={{ width: '100%' }}
                                disabled={isDisabled}
                            />
                        </Grid>
                        <Grid size={{ xs: 8, md: 3, xl: 2 }}>
                            <TimeZoneDropdown
                                paramTimeZone={paramTimeZone}
                                setParamTimeZone={setParamTimeZone}
                                isDisabled={isDisabled}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 3, xl: 2 }}>
                            <RunButton
                                onClick={getReportData}
                                isLoading={isLoading}
                                isDisabled={isDisabled || paramCobrand?.length === 0}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {noReportsAvailable && (
                <p className="mt-3 rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm font-semibold text-red-800">
                    The <em>{reportDisplayName}</em> report is not available for the selected client ({clientDisplayName}).
                </p>
            )}
        </div>
    );
};

export default ReportsHeader;
